import * as React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const TeamsIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg role="presentation" focusable="false" viewBox="0 0 32 32" className={classes.svg}>
      <g>
        <circle cx="17.00001" cy="6.00001" r="4.66666" fill="#7b83eb" />
        <path
          d="M16.66663,7H12.4411q.01017.04669.0213.09326l.00189.00781c.00684.02857.0141.05707.02143.08551A4.671,4.671,0,0,0,18,10.55884V8.33331A1.33727,1.33727,0,0,0,16.66663,7Z"
          opacity="0.1"
        />
        <path
          d="M15.66663,8H12.78271A4.667,4.667,0,0,0,17,10.66663V9.33331A1.33727,1.33727,0,0,0,15.66663,8Z"
          opacity="0.2"
        />
        <circle cx="27.5" cy="7.50001" r="3.5" fill="#5059c9" />
        <path
          d="M30.49976,12H22.63882a.63906.63906,0,0,0-.63906.63906v8.11026A5.12132,5.12132,0,0,0,25.966,25.8339a5.00551,5.00551,0,0,0,6.03372-4.89636V13.5A1.5,1.5,0,0,0,30.49976,12Z"
          fill="#5059c9"
        />
        <path
          d="M25,13.5V23a7.99479,7.99479,0,0,1-14.92,4,7.17277,7.17277,0,0,1-.5-1,8.36694,8.36694,0,0,1-.33-1A8.24022,8.24022,0,0,1,9,23V13.5A1.498,1.498,0,0,1,10.5,12h13A1.498,1.498,0,0,1,25,13.5Z"
          fill="#7b83eb"
        />
        <path
          d="M15.66663,8H12.78271A4.667,4.667,0,0,0,17,10.66663V9.33331A1.33727,1.33727,0,0,0,15.66663,8Z"
          opacity="0.2"
        />
        <path
          d="M18,12V24.67a1.32024,1.32024,0,0,1-1.04,1.29.966.966,0,0,1-.29.04H9.58a8.36694,8.36694,0,0,1-.33-1A8.24022,8.24022,0,0,1,9,23V13.5A1.498,1.498,0,0,1,10.5,12Z"
          opacity="0.1"
        />
        <path
          d="M17,12V25.67a.96746.96746,0,0,1-.04.29A1.3203,1.3203,0,0,1,15.67,27H10.08a7.17277,7.17277,0,0,1-.5-1,8.36694,8.36694,0,0,1-.33-1A8.24022,8.24022,0,0,1,9,23V13.5A1.498,1.498,0,0,1,10.5,12Z"
          opacity="0.2"
        />
        <path
          d="M17,12V23.67A1.33588,1.33588,0,0,1,15.67,25H9.25A8.24022,8.24022,0,0,1,9,23V13.5A1.498,1.498,0,0,1,10.5,12Z"
          opacity="0.2"
        />
        <path
          d="M10.5,12A1.498,1.498,0,0,0,9,13.5V23a8.24022,8.24022,0,0,0,.25,2h5.42A1.33588,1.33588,0,0,0,16,23.67V12Z"
          opacity="0.2"
        />
        <path
          d="M1.33334,8H14.6667A1.33333,1.33333,0,0,1,16,9.33333V22.66666A1.33333,1.33333,0,0,1,14.6667,24H1.33334A1.33334,1.33334,0,0,1,0,22.66666V9.33334A1.33334,1.33334,0,0,1,1.33334,8Z"
          fill="#4b53bc"
        />
        <path d="M11.97961,12.975H8.99081v8.0203H7.02654V12.975H4.02042V11.00466h7.95919Z" fill="#fff" />
      </g>
    </svg>
  ),
  displayName: 'TeamsIcon',
});
